import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { ProductsModel } from './produtos.modelview';
import { ProdutosPageProvider } from './produtos.provider';
import { JsonPipe } from '@angular/common';
import { json } from 'body-parser';

/**
 * Generated class for the ProdutosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-produtos',
  templateUrl: 'produtos.html',
})
export class ProdutosPage {

  isBrowser: boolean = false;
  model: ProductsModel = new ProductsModel()

  tipo: string = ""

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private loadingController: LoadingController,
    public productsPageProvider: ProdutosPageProvider) {

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProdutosPage');
    this.getProducts()
  }
 
  getProducts() {
    let loading = this.loadingController.create({
      content: "Carregando",
      enableBackdropDismiss: false
    })

    loading.present()

    this.productsPageProvider.requestProducts().subscribe(model => {
      this.model = model;
      loading.dismiss()
    }, error => {
      loading.dismiss()
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/produtos/produtos.ts